<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Manage Product Licence</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-1/2">
                        <div class="account-body">
                            <div class="form-field">
                                <label>Product</label>
                                <select v-model="product">
                                    <option :value="null">-- Select a product --</option>
                                    <option v-for="(productName, productCode) in products" :value="productCode">
                                        {{ productName }}
                                    </option>
                                </select>
                                <p class="text-sm bg-red-100 border-solid border-l-4 border-red-600 text-red-600 py-2 px-3 mt-2" v-if="hasNoEnablement">Subscription does not feature this service</p>
                                <p class="text-sm bg-orange-100 border-solid border-l-4 border-orange-600 text-orange-600 py-2 px-3 mt-2" v-if="!hasNoEnablement">Ensure Account has sufficient enablement for this service</p>
                            </div>

                            <div class="form-field">
                                <label>Identifier</label>
                                <input type="text" v-model="identifier">
                                <p class="text-sm text-gray-600 mt-1">The identifier from the product service to link this User.</p>
                            </div>

                            <div class="form-field">
                                <label>Active</label>
                                <CheckBox v-model="active" />
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-1/2">
                        <div class="account-body">
                            <div class="form-field">
                                <label>Licence Expires</label>
                                <simple-date-time-picker
                                    v-model="expires">
                                </simple-date-time-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">
                        <button class="btn-danger muted" type="button" @click="handleDeleteLicence">Delete</button>
                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary muted" type="button" :disabled="submitIsDisabled" @click="handleSaveLicence">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ProductLicencesView',
        props: {
            //
        },
        data() {
            return {
                products: {
                    'media-database': 'Media Database',
                },
                product: null,
                expires: null,
                identifier: null,
                active: false,
                subscription: null,
            }
        },
        mounted() {
            this.loadData()

            this.setMetaTitle('Product Licences | JournoLink Control')
        },
        methods: {
            loadData() {
                axios.get(route('productlicences.show', this.$route.params.licenceId))
                    .then(licenceResponse => {
                        this.product = licenceResponse.data.product
                        this.expires = licenceResponse.data.expires
                        this.identifier = licenceResponse.data.identifier
                        this.active = licenceResponse.data.active

                        let accountId = licenceResponse.data.user?.account_id

                        axios.get(route('subscriptions.show', accountId))
                            .then(subscriptionResponse => {
                                this.subscription = subscriptionResponse.data.subscription
                            })
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            initialise() {
                if (!this.subscription) {
                    return
                }

                this.expires = this.subscription.expires
            },
            /**
             * Handle a click event to create a new licence.
             *
             * @return {void}
             */
            handleSaveLicence() {
                axios.put(route('productlicences.update', this.$route.params.licenceId), {
                    product: this.product,
                    expires: moment(this.expires).format('YYYY-MM-DD'),
                    identifier: this.identifier,
                    active: this.active ? 1 : 0,
                })
                    .then(response => {
                        this.closeView()
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            /**
             * Handle a click event to delete the current licence.
             *
             * @return {void}
             */
            handleDeleteLicence() {
                this.alert.fire({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to delete this licence?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, continue',
                    confirmButtonColor: '#E3342F',
                    cancelButtonText: 'No, go back'
                })
                    .then((selected) => {
                        if (selected.value) {
                            axios.delete(route('productlicences.update', this.$route.params.licenceId))
                                .then(response => {
                                    this.closeView()
                                })
                                .catch(e => {
                                    console.error({e})
                                })
                        }
                    })
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$root.goBack()
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
        computed: {
            hasNoEnablement() {
                if (!this.product) {
                    return false
                }

                let enablement = this.subscription?.enablements?.find(e => e.permission === this.product)

                return enablement ? enablement.value === 0 : true
            },
            /**
             * Determine if the submit button should be disabled.
             *
             * @return {boolean}
             */
            submitIsDisabled() {
                return !this.product || !this.expires || this.hasNoEnablement
            },
        },
    }
</script>
